import { Permissions, UserRight, UserRights } from "./models/userRights.models";
import axiosInstance from "./axios";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchUserRights = async (bearerToken): Promise<UserRights[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Users/self/permissions`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch user rights:", error);
    throw error;
  }
};

export const adminFetchUserPermissions = async (
  bearerToken: string,
  userId: number
): Promise<UserRight[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Admin/users/${userId}/permissions`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch user rights:", error);
    throw error;
  }
};

export const fetchUserPermissions = async (
  bearerToken: string,
  userId: number,
  companyId: number,
  organizationId: number
): Promise<UserRight[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Users/${companyId}/permissions/${userId}${organizationId ? `?organizationId=${organizationId}` : ""}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch user permissions:", error);
    throw error;
  }
};
